<template>
  <div class="user-footer" :class="{ small: generalStore.sidebarSmall }" v-if="userProfile">
    <NicePopup no-padding class="grow" ref="user">
      <template #trigger>
        <div class="user clickable">
          <NiceAvatar class="user-avatar" :hash="userProfile.email" :text="userProfile.first_name + ' ' + userProfile.last_name" gradient />
          <div class="user-info">
            <div class="title">{{ userProfile.first_name }} {{ userProfile.last_name }}</div>
            <div class="subtitle">{{ userProfile.email }}</div>
            <div class="subtitle danger text-bold" v-if="!generalStore.production">DEVELOPMENT</div>
          </div>
          <NiceIcon class="icon" icon="icon-more-vertical" />
        </div>
      </template>

      <template #content>
        <div class="list-style">
          <div class="user">
            <NiceAvatar class="user-avatar" :hash="userProfile.email" :text="userProfile.first_name + ' ' + userProfile.last_name" gradient />
            <div class="user-info">
              <div class="title">{{ userProfile.first_name }} {{ userProfile.last_name }}</div>
              <div class="subtitle">{{ userProfile.email }}</div>
              <div class="subtitle danger text-bold" v-if="!generalStore.production">DEVELOPMENT</div>
            </div>
          </div>
          <!-- <div class="element">
            <NiceIcon icon="icon-settings" /><span>Settings</span>
          </div> -->
          <div class="element clickable" @click="changeLanguage">
            <NiceIcon icon="icon-globe" /><span>
              {{ generalStore.languages[generalStore.language] }}
            </span>
          </div>
          <div class="element clickable" @click="generalStore.toggleTheme"><NiceIcon icon="icon-droplet" /><span v-translate>Theme</span></div>
          <div class="divider"></div>
          <div class="element clickable" @click="tryToLogout">
            <NiceConfirmModal
              name="logout"
              @confirm="confirmLogout"
              :title="$gettext('Logout')"
              :message="$gettext('Are you sure you want to logout?')"
            />
            <NiceIcon icon="icon-log-out" /><span v-translate>Sign out</span>
          </div>
        </div>
      </template>
    </NicePopup>
  </div>
</template>

<script setup>
import { computed, inject } from "vue";
// import avatar from "gradient-avatar";
const nice = inject("nice");
import gettext from "@/language";

import { useGeneralStore } from "@/store/general.store";
import { useAuthStore } from "@/store/auth.store";
const generalStore = useGeneralStore();
const authStore = useAuthStore();

const userProfile = computed(() => authStore.userProfile);

// const color = computed(() => {
//   return avatar("uid");
// });

function changeLanguage() {
  const newLanguage = gettext.current == "en" ? "sl" : "en";
  generalStore.setLanguage(newLanguage);
}

function tryToLogout() {
  nice.modal("logout", true);
}

function confirmLogout() {
  authStore.logout();
}
</script>

<style lang="scss" scoped>
.user-footer {
  display: flex;
  align-items: center;
  // padding: 1rem;

  .list-style {
    .element {
      span {
        flex-grow: 1;
      }
      .icon {
        border-radius: 50%;
        width: 18px;
        height: 18px;
        margin-right: 0.5rem;
        background: currentColor;
      }
    }
  }

  &.small {
    .user.clickable {
      justify-content: center;
      .user-info {
        display: none;
      }

      .user-avatar {
        margin-right: 0;
      }

      .icon {
        display: none;
      }
    }
  }

  .user {
    display: flex;
    align-items: center;

    &.clickable {
      padding: 1rem;
      &:hover {
        background: var(--hover-color);
      }
    }

    .user-avatar {
      flex-shrink: 0;
      margin-right: 0.8rem;
    }

    .user-info {
      flex-grow: 1;

      .title {
        font-weight: 600;
      }

      .subtitle {
        font-size: 0.7em;
      }
    }

    .icon {
      flex-shrink: 0;
      height: 20px;
      width: 20px;
    }
  }

  .user-notifications,
  .user-more {
    flex-shrink: 0;
    height: 20px;
    width: 20px;
    margin-left: 0.5rem;
  }
}
</style>
